import React from 'react';
import { Global } from '@emotion/react';
import top from '@/assets/slambet/images/background/bg.png';
import bgMb from '@/assets/slambet/images/background/bgMobile.png';

export default function index() {
  return (
    <Global
      styles={{
        body: {
          backgroundImage: `url(${top}), linear-gradient(180deg, var(--bc-colors-beta-700), var(--bc-colors-beta-800))`,
          backgroundPosition: 'top, center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100%',
          backgroundAttachment: 'fixed',
          '@media (max-width: 767px)': {
            background: `url(${bgMb}), linear-gradient(180deg, var(--bc-colors-beta-700), var(--bc-colors-beta-800))`,
            backgroundSize: 'contain',
            backgroundPosition: 'top',
            backgroundRepeat: 'no-repeat',
          },
        },
      }}
    />
  );
}
